export type EnquiryDateRangePreset = "all" | "today" | "last7" | "last30" | "custom";

export type EnquiryDateRangeFilter = {
    preset: EnquiryDateRangePreset;
    from: string;
    to: string;
};

export const DEFAULT_ENQUIRY_DATE_RANGE: EnquiryDateRangeFilter = {
    preset: "all",
    from: "",
    to: "",
};

export const hasActiveDateRange = (range: EnquiryDateRangeFilter) =>
    range.preset !== "all" || Boolean(range.from || range.to);
